import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource'
import App from './App'
import Store from './Store.js'
import Router from './Router.js'
import Keen from 'keen-ui'

Vue.use(Keen)
Vue.use(VueResource)
Vue.use(VueI18n)

Vue.http.options.emulateJSON = true // application/x-www-form-urlencoded

// Global interceptor to inject token in request and catch 401 responses globally
Vue.http.interceptors.push((request, next) => {
  // console.log('httpRequest >>> ' + request.url)
  if (Store.state.authToken) {
    // console.log('httpRequest >>> authToken present in Store.state, adding it as request header')
    Vue.http.headers.common['SFY_ORDER_TRACKING_TOKEN'] = Store.state.authToken
  }

  next((response) => {
    if (response.status === 401) {
      console.log('Interceptor: 401 not authorized')
      Store.commit('userAuthFail', {code: 401, message: ''})
      Router.push({name: 'login'})
    }
  })
})

// Fetch AuthToken from localstorage
let token = window.localStorage.getItem('authToken')
function gup (name, url) {
  if (!url) url = document.location.href
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  var regexS = '[\\?&]' + name + '=([^&#]*)'
  var regex = new RegExp(regexS)
  var results = regex.exec(url)
  return results == null ? null : results[1]
}

// Fetch AuthToken from url
if (!token || token === 'null') {
  // console.log('No token found in local storage. Fetching from URL')
  const searchedToken = gup('token', document.location.search)
  if (searchedToken) token = searchedToken
  // console.log('Token fetch from URL = ' + token)
};

if (token) {
  Store.commit('userAuthSuccess', token)
  Store.dispatch('getUserInfo', token)
}

// Store user if exists
const user = window.localStorage.getItem('user')

if (user !== null) {
  Store.commit('setUser', JSON.parse(user))
}

// TODO la langue dynamiser en fonction du domaine ou autre méthode de choix de langue
var lang = 'fr'

// Setup locale
Vue.locale(lang, function () {
  return new Promise((resolve, reject) => {
    // Fetch online translations
    Vue.http.get(process.env.API_URL + '/language/' + lang).then(
      (response) => {
        if (response.body && response.body.hasOwnProperty(lang)) {
          // console.log('response.body', response.body)
          // Set available filters for orders
          if (response.body[lang].orders.filters.tabs) {
            Store.commit('filters', response.body[lang].orders.filters.tabs)
          }

          // Return the locale json
          resolve(response.body[lang])
          Vue.config.lang = lang
        }
        else {
          console.log('Locale ' + lang + ' is not available')
          reject()
        }
      },
      (response) => {
        console.log('Error during the tranlation load')
        reject()
      }
    )
  })
}, function () {
  Vue.config.lang = lang
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router: Router,
    store: Store,
    template: '<App/>',
    components: { App }
  })
})



// WEBPACK FOOTER //
// ./src/main.js